<ul class="list-none p-0 m-0 border-top-1 surface-border">
  <li
    *ngFor="let field of fields; let i = index"
    class="flex align-items-center py-3 px-3 flex-wrap"
    [ngClass]="{ 'surface-ground': i % 2 !== 0 }"
  >
    <div class="text-500 font-medium w-full md:w-4">{{ field.label }}</div>
    <div class="text-900 w-full md:w-8">
      <ng-container *ngIf="field.badge; else textValue">
        <p-tag
          [value]="(field.value != null ? field.value.toString() : '') | uppercase"
          [severity]="field.badge.severity"
          [icon]="field.badge.icon ?? ''"
        ></p-tag>
      </ng-container>
      <ng-template #textValue>{{ field.value ?? '—' }}</ng-template>
    </div>
  </li>
</ul>
